import type { ShipmentCarrier } from "~/shared/schemas/shipment-management-schema.ts";

export const yesNoOptions = [
	{ label: "Yes", value: "yes" },
	{ label: "No", value: "no" },
];

export const initFormState = {
	needHelpWithSalvage: "no",
	salvageAmount: 0,
	estimatedClaimAmount: 0,
	actualClaimAmount: 0,
	tempRecorder: "no",
	fedInspection: "no",
	claimReason: 0,
	claimExceedPayAmount: "no",
	contactName: "",
	contactEmail: "",
	contactPhone: "",
	contactExtension: "",
	claimDetails: "",
};

export type ClaimsFormData = typeof initFormState & {
	poNumber: string;
	customerName: string;
	carrier: ShipmentCarrier | undefined;
	loadDate: string | null | undefined;
	deliveryDate: string | null | undefined;
};
